export default __webpack_public_path__ + "static/media/IMG_0376-2.83f0c8ed.jpg";